/** Medidas das etiquetas: o modelo guarda décimos de mm (inteiro); a tela mostra mm com uma casa ("50,5"). */
export const mmText = (mm10: number): string => {
  const sign = mm10 < 0 ? "-" : "";
  const a = Math.abs(mm10);
  const dec = a % 10;
  return `${sign}${Math.trunc(a / 10)}${dec ? `,${dec}` : ""}`;
};

/** "50", "50,5" ou "50.5" → 505; mais de uma casa decimal, negativo ou texto → null (sem float). */
export function parseMm(text: string): number | null {
  const m = /^(\d{1,4})(?:[,.](\d))?$/.exec(text.trim());
  if (!m) return null;
  return Number(m[1]) * 10 + Number(m[2] ?? 0);
}

export type LabelPrintItem = { id: string; name: string; detail: string; copies: number };
const KEY = "cx:label-print-items";

/** Seleção da lista de produtos/contatos → tela de impressão (só nesta aba; sem o storage a tela começa vazia). */
export function saveLabelItems(items: LabelPrintItem[]): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(items.slice(0, 200)));
  } catch {
    /* storage indisponível: a pessoa escolhe os registros na tela de impressão */
  }
}
export function takeLabelItems(): LabelPrintItem[] {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    const v: unknown = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(v)) return [];
    return v
      .filter(
        (x): x is LabelPrintItem =>
          !!x &&
          typeof x.id === "string" &&
          /^[0-9A-HJKMNP-TV-Z]{26}$/.test(x.id) &&
          typeof x.name === "string" &&
          typeof x.detail === "string",
      )
      .map((x) => ({ id: x.id, name: x.name.slice(0, 200), detail: x.detail.slice(0, 200), copies: 1 }))
      .slice(0, 200);
  } catch {
    return [];
  }
}
